const json = {
  // 路由权限字段配置值
  routeSetting: {
    liulan: "liulan", //浏览权限
  },
  config: {
    bool: [
      {
        value: true,
        label: "是",
      },
      {
        value: false,
        label: "否",
      },
    ],
    sexes: [
      {
        name: "未知",
        id: 0,
      },
      {
        name: "男",
        id: 1,
      },
      {
        name: "女",
        id: 2,
      },
    ],
    genderList: [
      {
        name: "先生",
        id: 1,
      },
      {
        name: "女士",
        id: 2,
      },
    ],
    payWay: {
      1: "现金",
      2: "银行",
      3: "支付宝",
      4: "微信",
      5: "POS机",
    },
    orderStatus: {
      10: {
        name: "待审核",
        color: "red",
      },
      0: {
        name: "被驳回",
        color: "pink",
      },
      5: {
        name: "草稿",
        color: "",
      },
      15: {
        name: "待收款",
        color: "orange",
      },
      16: {
        name: "部分收款",
        color: "orange",
      },
      20: {
        name: "已结单",
        color: "color3",
      },
      100: {
        name: "已关闭",
        color: "color9",
      },
    },
    propertyTypes: ["住房", "商住", "别墅", "写字楼", "商铺"],
    propertyTypeMap: [
      { label: "住房", value: 1 },
      { label: "商住", value: 2 },
      { label: "别墅", value: 3 },
      { label: "写字楼", value: 4 },
      { label: "商铺", value: 5 },
    ],
    openDays: [
      { value: "", label: "全部" },
      { value: 0, label: "最近开盘" },
      { value: 7, label: "最近7天" },
      { value: 15, label: "最近15天" },
      { value: 30, label: "最近30天" },
      { value: 90, label: "最近3个月" },
    ],
    saleStatusList: [
      { value: "", label: "全部" },
      { value: 1, label: "待售" },
      { value: 2, label: "即将开盘" },
      { value: 3, label: "在售" },
      { value: 4, label: "下期待开" },
      { value: 5, label: "已售罄" },
    ],
    suitableOperations: [
      "餐饮美食",
      "服饰鞋包",
      "休闲娱乐",
      "美容美发",
      "生活服务",
      "百货超市",
      "酒店宾馆",
      "家居建材",
    ],
    decorations: ["毛坯", "简装", "普装", "精装", "豪装"],
    orientations: ["东", "南", "西", "北", "东北", "西北", "东南", "西南"],
    propertyRightLimits: ["40年", "50年", "70年"],
    propertyRightTypes: ["商品房", "经济适用房", "已购公房", "央产房", "其他"],
    houseLevels: ["A级", "B级", "C级"],
    houseAges: ["不满两年", "满两年", "满五年"],
    reportStatusList: [
      "待审报备",
      "已审报备",
      "报备失败",
      "有效客户",
      "无效客户",
      "已成交",
    ],
    houseStatusList: [
      {
        value: "空闲",
      },
      {
        value: "出租中",
      },
      {
        value: "自住",
      },
    ],
    expectSaleCycleList: [
      {
        value: "越快越好",
      },
      {
        value: "观望，价格合适再出售",
      },
    ],
    routineHouseViewTimeList: [
      {
        value: "周一",
        label: "周一",
        children: [
          {
            value: "上午",
            label: "上午",
          },
          {
            value: "中午",
            label: "中午",
          },
          {
            value: "下午",
            label: "下午",
          },
          {
            value: "晚上",
            label: "晚上",
          },
        ],
      },
      {
        value: "周二",
        label: "周二",
        children: [
          {
            value: "上午",
            label: "上午",
          },
          {
            value: "中午",
            label: "中午",
          },
          {
            value: "下午",
            label: "下午",
          },
          {
            value: "晚上",
            label: "晚上",
          },
        ],
      },
      {
        value: "周三",
        label: "周三",
        children: [
          {
            value: "上午",
            label: "上午",
          },
          {
            value: "中午",
            label: "中午",
          },
          {
            value: "下午",
            label: "下午",
          },
          {
            value: "晚上",
            label: "晚上",
          },
        ],
      },
      {
        value: "周四",
        label: "周四",
        children: [
          {
            value: "上午",
            label: "上午",
          },
          {
            value: "中午",
            label: "中午",
          },
          {
            value: "下午",
            label: "下午",
          },
          {
            value: "晚上",
            label: "晚上",
          },
        ],
      },
      {
        value: "周五",
        label: "周五",
        children: [
          {
            value: "上午",
            label: "上午",
          },
          {
            value: "中午",
            label: "中午",
          },
          {
            value: "下午",
            label: "下午",
          },
          {
            value: "晚上",
            label: "晚上",
          },
        ],
      },
      {
        value: "周六",
        label: "周六",
        children: [
          {
            value: "上午",
            label: "上午",
          },
          {
            value: "中午",
            label: "中午",
          },
          {
            value: "下午",
            label: "下午",
          },
          {
            value: "晚上",
            label: "晚上",
          },
        ],
      },
      {
        value: "周日",
        label: "周日",
        children: [
          {
            value: "上午",
            label: "上午",
          },
          {
            value: "中午",
            label: "中午",
          },
          {
            value: "下午",
            label: "下午",
          },
          {
            value: "晚上",
            label: "晚上",
          },
        ],
      },
    ],
    payRequireList: [
      {
        value: "全款",
      },
      {
        value: "支持按揭",
      },
    ],
    householdStatusList: [
      {
        value: "有户口,可迁出",
      },
      {
        value: "无户口",
      },
    ],
    sellReasonList: [
      {
        value: "变现换钱",
      },
      {
        value: "改善居住条件",
      },
      {
        value: "急等用钱",
      },
      {
        value: "置换新房",
      },
    ],
    customerLevels: [
      {
        value: 2,
        label: "一星(普通)",
      },
      {
        value: 3,
        label: "二星(优质)",
      },
      {
        value: 4,
        label: "三星(精准)",
      },
    ],
    customerDemands: [
      {
        value: 1,
        label: "二手房求购",
      },
      {
        value: 2,
        label: "新房求购",
      },
      {
        value: 3,
        label: "求租",
      },
    ],
    auditStatusList: ["待审报备", "已审报备", "报备失败"],
    marryStatusList: ["未婚", "已婚", "离异"],
    marryStatusList2: [
      { label: "未婚", value: 1 },
      { label: "已婚", value: 2 },
      { label: "离异", value: 3 },
      { label: "其他", value: 4 },
    ],
    mortgageStatusList: ["有抵押", "无抵押"],
    parkStatus: [
      { value: true, label: "有车位" },
      { value: false, label: "无车位" },
    ],
    degreeStatus: [
      { value: true, label: "有学位" },
      { value: false, label: "无学位" },
    ], //学位情况
    priceLimit: [
      {
        value: "0-40",
        label: "40万以下",
      },
      {
        value: "60-80",
        label: "60-80万",
      },
      {
        value: "80-100",
        label: "80-100万",
      },
      {
        value: "100-150",
        label: "100-150万",
      },
      {
        value: "150-200",
        label: "150-200万",
      },
      {
        value: "200-300",
        label: "200-300万",
      },
      {
        value: "300-1000000000",
        label: "300万以上",
      },
    ],
    buildingAreaLimit: [
      {
        value: "0-50",
        label: "50㎡以下",
      },
      {
        value: "50-70",
        label: "50-70㎡",
      },
      {
        value: "70-90",
        label: "70-90㎡",
      },
      {
        value: "90-110",
        label: "90-110㎡",
      },

      {
        value: "110-130",
        label: "110-130㎡",
      },
      {
        value: "130-150",
        label: "130-150㎡",
      },
      {
        value: "150-200",
        label: "150-200㎡",
      },
      {
        value: "200-1000000",
        label: "200㎡以上",
      },
    ],
    floorNumberLimit: [
      { value: "0-6", label: "6层以下" },
      { value: "6-12", label: "6-12层" },
      { value: "12-18", label: "12-18层" },
      { value: "18-1000", label: "18层以上" },
    ],
    houseStatus: ["有效", "封盘", "暂缓", "预订", "内成交", "外成交"],
    roomNum: ["一室", "二室", "三室", "四室", "四室以上"],
    dealStatus: ["待结佣", "部分结佣", "已结佣", "已关闭", "待审业绩"],
    performanceTypes: ["客源成交人", "客源合作人", "项目方抽成"],
    commissionStatusList: ["待结佣", "部分结佣", "已结佣"],
    communityScopeList: ["我关注的"],
    communityStatusList: ["草稿", "待审核", "被驳回"],
    waterUseTypeList: ["民用水", "商用水"],
    heatingTypeList: ["自采暖", "小区集中供暖", "市政供暖"],
    electricityTypeList: ["民用电", "商用电"],
    buildingStructureList: ["混凝土结构", "钢结构", "木结构", "砌体结构"],
    buildingTypeList: [
      "多层",
      "小高层",
      "高层",
      "超高层",
      "花园洋房",
      "独栋别墅",
      "双拼别墅",
      "联排别墅",
      "三拼别墅",
      "叠加别墅",
      "四合院",
      "板楼",
      "塔楼",
      "楼塔组合",
    ],
    communityOfferStatusList: [
      { label: "未报盘", value: 1 },
      { label: "在售/租", value: 2 },
      { label: "封盘", value: 3 },
      { label: "无效", value: 4 },
      { label: "已成交", value: 5 },
    ],
    invalidReasonList: ["暂缓", "内成交", "外成交", "信息有误", "其他"],
    keyList: ["实体钥匙", "电子钥匙"],
    windowTypeList: ["未知窗户类型", "落地窗", "普通窗", "飘窗", "无窗"],
    educationList: [
      { label: "大专统招", value: 1 },
      { label: "大专非统招", value: 2 },
      { label: "本科统招", value: 3 },
      { label: "本科非统招", value: 4 },
      { label: "高中/中专", value: 5 },
      { label: "硕士", value: 6 },
      { label: "研究生", value: 7 },
      { label: "博士", value: 8 },
      { label: "其他", value: 9 },
    ],
    workingStatus: {
      //任职状态
      PENDING: { label: "待入职", color: "orange" },
      INCUMBENCY_FORMAL: { label: "正式", color: "green" },
      PART_TIME: { label: "兼职", color: "pink" },
      LEAVE: { label: "离职", color: "gray" },
      INCUMBENCY_INTERNSHIP: { label: "试用期", color: "color6" },
      suoding: { label: "锁定", color: "red" },
    },
    workingStatus2: [
      //任职状态
      { label: "离职", value: "LEAVE" },
      { label: "待入职", value: "PENDING" },
      { label: "正式", value: "INCUMBENCY_FORMAL" },
      { label: "试用期", value: "INCUMBENCY_INTERNSHIP" },
      { label: "兼职", value: "PART_TIME" },
    ],
    workingStatus3: {
      0: "LEAVE",
      1: "INCUMBENCY",
      2: "PENDING",
      3: "PART_TIME",
    },
    scope: [
      { label: "全部房源", value: "" },
      { label: "分销楼盘", value: "1" },
      { label: "我关注的", value: "2" },
    ],
    houseType: [
      //户型
      { label: "一室", value: 1 },
      { label: "二室", value: 2 },
      { label: "三室", value: 3 },
      { label: "四室", value: 4 },
      { label: "四室以上", value: 5 },
    ],
    averagePriceRange: [
      //总价
      "8000以下",
      "8000-10000",
      "10000-15000",
      "15000-20000",
      "20000-30000",
      "30000以上",
    ],
    commissionRange: [
      //佣金
      "2%以下",
      "2%-3%",
      "3%-4%",
      "4%-5%",
      "5%-6%",
      "6%-7%",
      "7%-8%",
      "8%-9%",
      "9%以上",
    ],
    areaRange: [
      "50㎡以下",
      "50-70㎡",
      "70-90㎡",
      "90-110㎡",
      "110-130㎡",
      "130-150㎡",
      "150-200㎡",
      "200㎡以上",
    ],
    scopeArr: [
      { name: "经纪公司", id: 2 },
      { name: "独立经纪", id: 3 },
      { name: "伙伴组织", id: 4 },
    ], //应用适用范围
    appTypeList: [
      { name: "新房作业", id: 1 },
      { name: "客源管理", id: 2 },
      { name: "作业助手", id: 3 },
      { name: "签约交易", id: 4 },
      { name: "拓客工具", id: 5 },
      { name: "综合行政", id: 6 },
    ], //应用分类
  },
  rules: {
    required(message = "不能为空") {
      return {
        required: true,
        trigger: ["blur", "change"],
        message,
      };
    },
    number: {
      message: "必须为正数",
      pattern: /^\d*(\.\d*)?$/,
      trigger: "blur",
    },
    pInt: {
      message: "必须为正整数",
      pattern: /^[1-9]\d*$/,
      trigger: "blur",
    },
    int: {
      message: "必须为整数",
      pattern: /^\d*$/,
      trigger: "blur",
    },
    tel: {
      pattern: /^1\d{10}$/,
      message: "目前只支持中国大陆的手机号码",
      trigger: "blur",
    },
    phone: {
      pattern: /^\d{3}-?\d{8}$|^\d{4}-?\d{7}$|^1\d{10}$/,
      message: "输入正确手机或座机号码",
      trigger: "blur",
    },
    tel2: {
      pattern: /^(1\d{10}|1\d{6}\*{4}|1\d{2}\*{4}\d{4})$/, //匹配带星号的电话号码
      message: "目前只支持中国大陆的手机号码",
      trigger: "blur",
    },
    m0m29: {
      message: "范围0-99整数",
      pattern: /^\d{0,2}$/,
      trigger: "blur",
    },
    m0m100: {
      message: "范围0-100整数",
      pattern: /^(\d{0,2}|100)$/,
      trigger: "blur",
    },
    m0m29p2: {
      message: "范围0-99,允许保留小数后两位",
      pattern: /^\d{0,2}?(\.\d{0,2})?$/,
      trigger: "blur",
    },
    m0m69: {
      message: "范围0-999999整数",
      pattern: /^\d{0,6}$/,
      trigger: "blur",
    },
    m0m69p2: {
      message: "范围0-999999,允许保留小数后两位",
      pattern: /^\d{0,6}?(\.\d{0,2})?$/,
      trigger: "blur",
    },
    m0m89p2: {
      message: "范围0-99999999,允许保留小数后两位",
      pattern: /^\d{0,8}?(\.\d{0,2})?$/,
      trigger: "blur",
    },
    m0m100p2: {
      message: "范围0-100,允许保留小数后两位",
      pattern: /^(\d|[1-9]\d|100)(\.\d{1,2})?$/,
      trigger: "blur",
    },
    dnl3: {
      message: "1-6位字母或者数字",
      pattern: /^[a-zA-Z0-9]{1,3}$/,
      trigger: "blur",
    },
    dnl6: {
      message: "1-6位字母或者数字",
      pattern: /^[a-zA-Z0-9]{1,3}$/,
      trigger: "blur",
    },
    d6: {
      message: "请输入6位验证码",
      pattern: /^\d{6}$/,
      trigger: "blur",
    },
    idNum: {
      message: "身份证号格式不对",
      pattern: /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
      trigger: "blur",
    },
    bankNum: {
      message: "银行卡号格式不对",
      pattern: /^([1-9]{1})([\d\s]{14,24})$/,
      trigger: "blur",
    },
  },
};

export default json;
